export default "__VITE_ASSET__V7Uu3j13__"